import React from 'react';
import { Reveal } from './Reveal';
export function Guarantee() {
  return <section className="w-full bg-surface px-4 py-20 sm:py-24" data-id="element-100" data-mp="1o3ncvzyfwkwu">
      <Reveal className="mx-auto max-w-2xl rounded-2xl border border-amber/50 bg-mist p-9 text-center shadow-premium sm:p-12" data-id="element-101" data-mp="1o3dmwcdeadr5">
        <div className="text-5xl" data-id="element-102" data-mp="1x4bsv07e8vcd">🛡️</div>
        <h2 className="mt-5 font-serif text-4xl leading-tight text-navy sm:text-5xl" style={{
        fontSize: "20px"
      }} data-id="element-103" data-mp="1x5d69bbvttx9">
          Protection de l’Achat Numérique pendant 7 Jours
        </h2>
        <p className="mt-3 font-serif text-xl italic text-amber sm:text-2xl" data-id="element-104" data-mp="14gfmt4vxpr2x">Achetez en toute confiance.</p>
        <p className="mt-6 text-sm leading-7 text-slate sm:text-base" data-id="element-105" data-mp="1j5luzicr2rmy">
          Votre achat est protégé pendant 7 jours en cas de double facturation, de problème d’accès que nous ne sommes
          pas en mesure de résoudre, ou si le produit numérique diffère de manière significative de ce qui est décrit
          sur cette page.
        </p>
        <p className="mt-4 text-sm leading-7 text-slate sm:text-base" data-id="element-106" data-mp="ln27270slr7w">
          Comme il s’agit d’un contenu numérique à accès immédiat, les remboursements volontaires pour simple changement
          d’avis ne sont pas disponibles une fois que les fichiers ont été consultés ou téléchargés, sauf lorsque la
          législation applicable en matière de protection des consommateurs l’exige.
        </p>
        <p className="mt-7 font-semibold text-sage" data-id="element-107" data-mp="12sr2qak2w46b">
          ✓ Livraison numérique immédiate · ✓ Paiement sécurisé · ✓ Assistance client · ✓ Protection d’achat de 7 jours
        </p>
      </Reveal>
    </section>;
}